module.exports = __webpack_public_path__ + "2bb1f93e7e4c471bec17a77a9fe3f135.svg";